module.exports = __webpack_public_path__ + "img/logo.96d0fc9f.png";